'use strict';

var CreateEntityModalDirective = function CreateEntityModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmStepEntitiesAndControlType',
    template: require('../templates/create-entity-modal.html'),
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
CreateEntityModalDirective.$inject = [];
module.exports = CreateEntityModalDirective;